import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Legacy route — closed PO list now lives at /admin/closedpos
const AdminClosedPO = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/admin/closedpos", { replace: true });
  }, [navigate]);
  return null;
};

export default AdminClosedPO;
